import(/* webpackMode: "eager", webpackExports: ["StakingProjectClient"] */ "/codebuild/output/src3094709904/src/github.com/Singularity-DAO/sfi-frontend/apps/dapp/app/staking/[id]/StakingProjectClient.tsx");
